import { render, staticRenderFns } from "./ViewBlog.vue?vue&type=template&id=5c1bf422&"
import script from "./ViewBlog.vue?vue&type=script&lang=js&"
export * from "./ViewBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports